import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@michelin/theme';
import { UserProfileDto } from 'src/app/shared/models/user/user-profile-dto';
import { UserProfileService } from 'src/app/shared/services/user-profile/user-profile.service';

@Component({
    selector: 'app-show-user-profile',
    templateUrl: './show-user-profile.component.html',
    styleUrl: './show-user-profile.component.scss',
    standalone: false
})
export class ShowUserProfileComponent implements OnInit {
  loading = false;
  id: number = null;
  currentProfile: UserProfileDto = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.id = this.route.snapshot.params['id'];
    this.userProfileService
      .findById(this.id)
      .subscribe((value) => (this.currentProfile = value))
      .add(() => (this.loading = false));
  }
}
